import React from 'react';
import { WinBigBanner } from '../../../../Components/WinBigBanner/WinBigBanner';
import { StatsCards } from '../../../../Components/StatsCards/StatsCards';
import { ProgressOverview } from '../../../../Components/ProgressOverview/ProgressOverview';
import { LeaderboardEventSummary } from '../../../../api/leaderboard-events';
import './LeaderboardSidebar.scss';
import useWindowDimensions from '../../../../hooks/useWindowDimensions';

interface LeaderboardSidebarProps {
  summary: LeaderboardEventSummary | null;
}

export const LeaderboardSidebar: React.FC<LeaderboardSidebarProps> = ({ summary }) => {
  const { width } = useWindowDimensions();
  const isMobile = width < 768;

  const progressData = summary
    ? [
        {
          label: 'Total Hours',
          value: summary.totalHours,
          max: summary.milestone,
        },
        {
          label: 'Total Reviews',
          value: summary.reviewsCount,
          max: summary.reviewMilestone,
        },
      ]
    : undefined;

  return (
    <div className="leaderboard-sidebar">
      {!isMobile ? <WinBigBanner /> : null}
      <StatsCards summary={summary} />
      {!isMobile ? <ProgressOverview data={progressData} /> : null}
    </div>
  );
};
